import { Typography } from "@mui/material";
import type { ObjectFilter, SelectOption } from "../../api/types/objectTypes";
import ObjectBooleanFilterEditorContent from "./ObjectBooleanFilterEditorContent";
import ObjectDateFilterEditorContent from "./ObjectDateFilterEditorContent";
import ObjectGuidFilterEditorContent from "./ObjectGuidFilterEditorContent";
import ObjectMultiSelectFilterEditorContent from "./ObjectMultiSelectFilterEditorContent";
import ObjectNumberFilterEditorContent from "./ObjectNumberFilterEditorContent";
import ObjectTextFilterEditorContent from "./ObjectTextFilterEditorContent";

interface Props {
  filter: ObjectFilter;
  onFilterChange: (filter: ObjectFilter) => void;
  selectOptions?: SelectOption[];
}

const ObjectFilterEditorContent = ({ filter, onFilterChange, selectOptions }: Props) => {
  const handleFilterChange = (partial: Omit<ObjectFilter, "fieldId">) => {
    onFilterChange({ fieldId: filter.fieldId, ...partial });
  };

  if (filter.numberFilter) {
    return (
      <ObjectNumberFilterEditorContent
        filter={filter.numberFilter}
        onFilterChange={(f) => handleFilterChange({ numberFilter: f })}
      />
    );
  }

  if (filter.textFilter) {
    return (
      <ObjectTextFilterEditorContent
        filter={filter.textFilter}
        onFilterChange={(f) => handleFilterChange({ textFilter: f })}
      />
    );
  }

  if (filter.dateFilter) {
    return (
      <ObjectDateFilterEditorContent
        filter={filter.dateFilter}
        onFilterChange={(f) => handleFilterChange({ dateFilter: f })}
      />
    );
  }

  if (filter.booleanFilter) {
    return (
      <ObjectBooleanFilterEditorContent
        filter={filter.booleanFilter}
        onFilterChange={(f) => handleFilterChange({ booleanFilter: f })}
      />
    );
  }

  if (filter.multiSelectFilter) {
    return (
      <ObjectMultiSelectFilterEditorContent
        filter={filter.multiSelectFilter}
        onFilterChange={(f) => handleFilterChange({ multiSelectFilter: f })}
        selectOptions={selectOptions}
      />
    );
  }

  if (filter.guidFilter) {
    return (
      <ObjectGuidFilterEditorContent
        filter={filter.guidFilter}
        onFilterChange={(f) => handleFilterChange({ guidFilter: f })}
        selectOptions={selectOptions}
      />
    );
  }

  return <Typography color="warning">Unsupported filter type</Typography>;
};

export default ObjectFilterEditorContent;
